import React from 'react';
import './SessionTimeoutWarning.css';

/**
 * Componente flotante de advertencia y renovación de sesión.
 * - Computadoras: Aparece en la parte superior derecha.
 * - Tablets y celulares: Aparece en la parte superior y al centro.
 * - Botón 'X': Cierra visualmente la notificación sin renovar la sesión.
 * - Al renovar con éxito: Muestra mensaje 'Sesión renovada con éxito' durante 3 segundos.
 */
export const SessionTimeoutWarning = ({
    show,
    countdown = 30,
    onKeepAlive,
    onClose,
    isSuccess = false,
    onCloseSuccess,
    isRenewing = false,
}) => {
    if (!show && !isSuccess) {
        return null;
    }

    return (
        <div
            className="session-timeout-banner card bg-dark text-white border-secondary"
            role="alert"
            aria-live="assertive"
        >
            <div className="card-body">
                {isSuccess ? (
                    // Estado de Éxito tras renovar
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center me-3">
                            <i className="bi bi-check-circle-fill text-success fs-4 me-3"></i>
                            <div>
                                <span className="fw-bold text-success d-block">Sesión renovada con éxito</span>
                                <small className="text-light opacity-75">Tu tiempo de trabajo ha sido extendido.</small>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            aria-label="Cerrar"
                            onClick={onCloseSuccess || onClose}
                            title="Cerrar notificación"
                        />
                    </div>
                ) : (
                    // Estado de Advertencia por Inactividad
                    <div>
                        <div className="d-flex align-items-start justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-clock-history text-warning fs-4 me-2"></i>
                                <span className="fw-bold text-warning">Aviso de Sesión</span>
                            </div>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                aria-label="Cerrar"
                                onClick={onClose}
                                title="Cerrar aviso (no renueva sesión)"
                            />
                        </div>
                        <p className="mb-3 text-light small">
                            Tu sesión está a punto de expirar ¿Deseas mantenerla abierta?
                        </p>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="badge bg-secondary font-monospace">
                                {countdown > 0 ? `${countdown}s restantes` : 'Expirando...'}
                            </span>
                            <button
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3"
                                onClick={onKeepAlive}
                                disabled={isRenewing}
                            >
                                {isRenewing ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                        Renovando...
                                    </>
                                ) : (
                                    'Mantener abierta'
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SessionTimeoutWarning;
